import { createContext } from 'react';

import { DashboardResponse } from '@totem/components/ticketing/ticketDashboard/types';

interface Context {
  loading: boolean;
  data: DashboardResponse | null;
}

const defaultValue: Context = {
  loading: true,
  data: null,
};

const TicketDashboardContext = createContext<Context>(defaultValue);

export default TicketDashboardContext;
